import { Seo, SITE_URL } from "../seo";
import { FAQS } from "../components/Faq";
import { faqJsonLd } from "../data/services";
import { Hero } from "../components/Hero";
import { Services } from "../components/Services";
import { AreasMarquee } from "../components/AreasMarquee";
import { Reviews } from "../components/Reviews";
import { Faq } from "../components/Faq";
import { QuoteForm } from "../components/QuoteForm";

export default function HomePage() {
  return (
    <>
      <Seo
        title="Arrow Locksmith — 24/7 Automotive & Residential Locksmith Winnipeg"
        description="Arrow Locksmith is Winnipeg's 24/7 mobile automotive and residential locksmith: car lockouts, home lockouts, key fob programming, transponder keys and broken key extraction. Call (204) 963-9081."
        path="/"
        jsonLd={[faqJsonLd(FAQS)]}
      />
      <main>
        <Hero />
        <Services />
        <AreasMarquee />
        <Reviews />
        <Faq />
        <QuoteForm />
      </main>
    </>
  );
}
